import React from 'react';
import { Select } from 'antd';
import { SlidersHorizontal, Store } from 'lucide-react';
import { StatusTag } from './page';
import { ALL_CHANNELS, CHANNEL_FILTER_OPTIONS, isChannelFiltered } from '../../utils/storeChannel';

/**
 * Filtro superior de canal (Moderno / Tradicional) para el detalle de
 * contrataciones y campañas. Filtra todo el contenido de la pantalla, por eso
 * muestra cuántos pisos quedan visibles de cuántos hay asignados.
 */
export default function ChannelFilter({ value = ALL_CHANNELS, onChange, counts, visibleStores, totalStores }) {
    const filtered = isChannelFiltered(value);

    return (
        <div className="shelf-card px-4 py-3">
            <div className="flex flex-wrap items-center gap-x-4 gap-y-3">
                <span className="flex items-center gap-1.5 text-[13px] font-medium text-surface-500">
                    <SlidersHorizontal className="text-[15px]" />
                    Filtrar por canal
                </span>

                <Select
                    value={value}
                    options={CHANNEL_FILTER_OPTIONS}
                    onChange={(next) => onChange?.(next || ALL_CHANNELS)}
                    className="min-w-[220px]"
                />

                <div className="flex flex-wrap items-center gap-2">
                    <StatusTag tone={filtered ? 'brand' : 'neutral'} icon={<Store />} className="tabular-nums">
                        {filtered ? `${visibleStores} de ${totalStores} pisos` : `${totalStores} pisos`}
                    </StatusTag>
                    {!filtered && counts && (
                        <>
                            <StatusTag tone="info" dot className="tabular-nums">
                                Moderno: {counts.moderno}
                            </StatusTag>
                            <StatusTag tone="warning" dot className="tabular-nums">
                                Tradicional: {counts.tradicional}
                            </StatusTag>
                        </>
                    )}
                </div>

                {filtered && <span className="text-xs text-surface-500">Inversión, analíticas, evidencias y resultados reflejan solo este canal.</span>}
            </div>
        </div>
    );
}
